// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1TfPs","bigColWidth":"Table_bigColWidth__2kb32","biggerColWidth":"Table_biggerColWidth__1UEgX","row":"Table_row__wWg1s","col":"Table_col__2hDJp"};